<template>
  <div>
    <el-top-nav-menu-4
      :logo="logoBase"
      companyTitle="商家开店"
      :dashboard="baseUrl"
      :Menu4Href="true"
      width="1180px"
      ref="topNavMenu"
    >
    </el-top-nav-menu-4>
    <div class="main-wrapper">
      <div class="business-open-shop">
        <div class="name-check">
          <div class="content-center">
            <div
              :style="idx === nameCheck.length - 1 ? { marginRight: 0 } : {}"
              :class="
                item.isActive ? 'content-block block-active' : 'content-block'
              "
              v-for="(item, idx) in nameCheck"
              :key="idx"
            >
              <div class="border-radius">
                <div
                  class="step-block"
                  style="font-family: PingFangSC-Semibold, PingFang SC"
                >
                  {{ idx + 1 }}
                </div>
              </div>
              <span style="font-family: PingFangSC-Regular, PingFang SC">{{
                item.name
              }}</span>
              <ul v-if="idx < nameCheck.length - 1">
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </div>
          </div>
        </div>
        <keep-alive :include="cachedViews">
          <router-view />
        </keep-alive>
        <el-dialog
          class="dialog-center"
          title="提示"
          :visible.sync="dialogVisible2"
          :show-close="false"
          width="300px"
          show-divider
          show-shadow
          custom-class="el-dialog--customize"
        >
          <span>网络请求超时，请稍后再试</span>
          <span slot="footer" style="text-align: center">
            <el-button
              size="mini"
              type="primary-font-mini"
              @click="closeModalTimeout"
              >确定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import logoBase from "../.././assets/images/logoS.png";
export default {
  name: "index",
  data() {
    return {
      logoBase,
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_SHOPPAGE_URL),
    };
  },
  computed: {
    dialogVisible2() {
      return this.$store.state.app.isShowDialogTimeout;
    },
    nameCheck() {
      return this.$store.state.app.nameCheck;
    },
    currentComponent() {
      return this.$store.state.app.currentComponent;
    },
    cachedViews() {
      console.log(
        this.$store.state.tagsView.cachedViews,
        "this.$store.state.tagsView.cachedViews"
      );
      return this.$store.state.tagsView.cachedViews;
    },
  },
  methods: {
    closeModalTimeout() {
      this.$store.commit("SET_IS_SHOW_DIALOG_TIMEOUT", false);
    },
    goHomePage() {
      this.$router.push("/index");
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-top-nav-menu4 {
  .sub-menu-wrapper-wrapper {
    .sub-menu-wrapper {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}
.main-wrapper,
.headerContent {
  /*min-width: 1263px;*/
  /*max-width: 1680px;*/
  width: 1180px;
  margin: 0 auto;
}
/* header */
.header {
  cursor: pointer;
  /*min-width:  .main-wrapper1080px;*/
  /*max-width: 1680px;*/
  height: 80px;
  background: rgba(255, 20, 47, 1);
  position: relative;
}
.headerLogo {
  width: 115px;
  height: 40px;
  position: absolute;
  top: 20px;
  left: 50px;
}
.headerLine {
  display: block;
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 1);
  border-radius: 1px;
  position: absolute;
  top: 32px;
  left: 171px;
}
.header .headerTxt {
  width: 128px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  position: absolute;
  top: 29px;
  left: 178px;
}
.business-open-shop {
  /*padding: 0 50px 0 50px;*/
  /*margin-bottom: 20px;*/
}
</style>
